import moment from 'moment';
import { Grid, Box, Typography } from '@mui/material';
import CakeIcon from '@mui/icons-material/Cake';
import { Table, TableRow, TableBody } from '@mui/material';

import { getAge } from '../../../../../../../common/utils/calculateAge';
import printPrettyPhoneNumber from '../../../../../../../common/utils/printPrettyPhoneNumber';
import { isDateToday } from '@/common/utils/time';

import { OverviewStyles, OverviewTableCell, OverviewCard } from '../Info';
import { displayGender } from '@/common/utils/utils';

const ClientInfo = props => {
  const { customerData } = props;
  const customerId = parseInt(customerData?.customer?.id);
  const classes = OverviewStyles();
  const formatDate = moment
    .utc(customerData?.customer?.dob)
    .format('MM/DD/YYYY');
  const customerAge = getAge(formatDate);
  const { addressLine1, addressLine2, city, state, postalCode } =
    customerData?.customer || {};
  let address = '';
  if (addressLine1) {
    address += addressLine1;
    if (addressLine2) {
      address += `, ${addressLine2}`;
    }
  }
  const cspParts = [];
  if (city) {
    cspParts.push(city);
  }
  if (state || postalCode) {
    cspParts.push([state, postalCode].filter(Boolean).join(' '));
  }
  const cityStatePostal = cspParts.join(', ');

  return (
    <OverviewCard>
      <Grid container spacing={1}>
        <Grid item xs={8}>
          <Box p={1}>
            <Typography className={classes.headingText} color="primary">
              Client
            </Typography>
            <Table className={classes.noBorder}>
              <TableBody>
                <TableRow>
                  <OverviewTableCell>
                    {customerData?.customer?.firstName
                      ? `${customerData?.customer?.firstName} ${customerData?.customer?.lastName}`
                      : '--'}
                  </OverviewTableCell>
                  <OverviewTableCell>
                    Mobile:{' '}
                    {customerData?.customer?.mobilePhone
                      ? ' ' +
                        printPrettyPhoneNumber(
                          customerData?.customer?.mobilePhone
                        )
                      : ' --'}
                  </OverviewTableCell>
                </TableRow>
                <TableRow>
                  <OverviewTableCell>{`${
                    customerData?.customer?.gender
                      ? `${displayGender(customerData?.customer?.gender)}, `
                      : ''
                  }${
                    customerData?.customer?.dob ? customerAge : '--'
                  }`}</OverviewTableCell>
                  <OverviewTableCell>
                    Work:{' '}
                    {customerData?.customer?.workPhone
                      ? ' ' +
                        printPrettyPhoneNumber(
                          customerData?.customer?.workPhone
                        )
                      : ' --'}
                  </OverviewTableCell>
                </TableRow>
                <TableRow>
                  <OverviewTableCell>
                    DOB:{' '}
                    {customerData?.customer?.dob != null ? formatDate : '--'}
                    {isDateToday(new Date(customerData?.customer?.dob)) && (
                      <CakeIcon
                        style={{
                          fontSize: '1rem',
                          verticalAlign: 'middle',
                          marginBottom: '4px',
                          marginLeft: '3px'
                        }}
                      />
                    )}
                  </OverviewTableCell>
                  <OverviewTableCell>
                    {customerData?.customer?.email ? (
                      <a
                        href={`mailto:${customerData?.customer?.email}`}
                        className={classes.email}
                      >
                        {customerData?.customer?.email}
                      </a>
                    ) : (
                      ' --'
                    )}
                  </OverviewTableCell>
                </TableRow>
                <TableRow>
                  <OverviewTableCell>
                    {address ? address : 'Address: --'}
                  </OverviewTableCell>
                  <OverviewTableCell>
                    Preferred Contact:{' '}
                    {customerData?.customer?.preferredContactMethod
                      ? customerData?.customer?.preferredContactMethod
                          .charAt(0)
                          .toUpperCase() +
                        customerData?.customer?.preferredContactMethod.slice(1)
                      : '--'}
                  </OverviewTableCell>
                </TableRow>
                <TableRow>
                  <OverviewTableCell>
                    {cityStatePostal ? cityStatePostal : 'City/State: --'}
                  </OverviewTableCell>
                  <OverviewTableCell>
                    Home Studio: {customerData?.customer?.homeStoreCode}
                  </OverviewTableCell>
                </TableRow>
                <TableRow>
                  <OverviewTableCell>POW ID: {customerId}</OverviewTableCell>
                  <OverviewTableCell></OverviewTableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box p={1}>
            <Typography className={classes.headingText} color="primary">
              Emergency Contact
            </Typography>
            <Table className={classes.noBorder}>
              <TableBody>
                {customerData?.customer?.emergencyContactName ||
                customerData?.customer?.emergencyContactPhone ||
                customerData?.customer?.emergencyContactEmail ? (
                  <>
                    <TableRow>
                      <OverviewTableCell>
                        Name:
                        {customerData?.customer?.emergencyContactName
                          ? ' ' + customerData?.customer?.emergencyContactName
                          : ' --'}
                        {customerData?.customer?.emergencyContactRelationship
                          ? ', ' +
                            customerData?.customer?.emergencyContactRelationship
                          : ''}
                      </OverviewTableCell>
                    </TableRow>
                    <TableRow>
                      <OverviewTableCell>
                        Phone:
                        {customerData?.customer?.emergencyContactPhone
                          ? ' ' +
                            printPrettyPhoneNumber(
                              customerData?.customer?.emergencyContactPhone
                            )
                          : ' --'}
                      </OverviewTableCell>
                    </TableRow>
                    <TableRow>
                      <OverviewTableCell>
                        Email:
                        {customerData?.customer?.emergencyContactEmail ? (
                          <a
                            href={`mailto:${customerData?.customer?.emergencyContactEmail}`}
                            className={classes.email}
                          >
                            {' ' +
                              customerData?.customer?.emergencyContactEmail}
                          </a>
                        ) : (
                          ' --'
                        )}
                      </OverviewTableCell>
                    </TableRow>
                  </>
                ) : (
                  <TableRow>
                    <OverviewTableCell>No Emergency Contact</OverviewTableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        </Grid>
      </Grid>
    </OverviewCard>
  );
};

export default ClientInfo;
